// extracted by mini-css-extract-plugin
module.exports = {"tabs":"CurrencyTabs_tabs__2cZZt","tabsButton":"CurrencyTabs_tabsButton__2BGo3","tabsButtonActive":"CurrencyTabs_tabsButtonActive__gB6e0"};